import {
    EXPORT_VEHICLES_PDF_REQUEST,
    EXPORT_VEHICLES_PDF_SUCCESS,
    EXPORT_VEHICLES_PDF_FAILURE,
    EXPORT_VEHICLES_EXCEL_REQUEST,
    EXPORT_VEHICLES_EXCEL_SUCCESS,
    EXPORT_VEHICLES_EXCEL_FAILURE
} from '../actions/export';

const initialState = {
    exporting: false,
    error: null
};

export default (state = initialState, action) => {
    switch (action.type) {
        case EXPORT_VEHICLES_PDF_REQUEST:
        case EXPORT_VEHICLES_EXCEL_REQUEST:
            return {
                ...state,
                exporting: true,
                error: null
            };
        case EXPORT_VEHICLES_PDF_SUCCESS:
        case EXPORT_VEHICLES_EXCEL_SUCCESS:
            return {
                ...state,
                exporting: false,
                error: null
            };
        case EXPORT_VEHICLES_PDF_FAILURE:
        case EXPORT_VEHICLES_EXCEL_FAILURE:
            return {
                ...state,
                exporting: false,
                error: action.payload.error
            };
        default:
            return state;
    }
};
